export const NavItems = [
  {
    title: "Home",
    url: "/",
    cName: "navlinks",
  },
  {
    title: "Sessions",
    url: "/sessions",
    cName: "navlinks",
  },
  {
    title: "Contact",
    url: "/contact-us",
    cName: "navlinks",
  },
];
export const studentNavItems = [
  {
    title: "Home",
    url: "/",
    cName: "navlinks",
  },
  {
    title: "Courses",
    url: "/courses",
    cName: "navlinks",
  },
  {
    title: "Sessions",
    url: "/sessions",
    cName: "navlinks",
  },
];

export const teacherNavItems = [
  {
    title: "Home",
    url: "/",
    cName: "navlinks",
  },
  {
    title: "Courses",
    url: "/courses",
    cName: "navlinks",
  },
  {
    title: "Sessions",
    url: "/sessions",
    cName: "navlinks",
  },
];
